import { AfterViewInit, ComponentRef, Directive, Input, OnDestroy, ViewContainerRef } from '@angular/core';
import { DataGridDefaultCellRendererComponent } from './data-grid-default-cell-renderer/data-grid-default-cell-renderer.component';

@Directive({
    selector: '[appDataGridComponentInjector]',
    standalone: true,
})
export class DataGridComponentInjectorDirective implements OnDestroy, AfterViewInit {
    @Input() appDataGridComponentInjector: [any, any] = [undefined, undefined];

    private column: any;
    private data: any;
    private componentReference: ComponentRef<any>[] = [];

    constructor(public viewContainerRef: ViewContainerRef) {}

    public ngAfterViewInit(): void {
        this.column = this.appDataGridComponentInjector[0];
        this.data = this.appDataGridComponentInjector[1];

        if (Array.isArray(this.column.customCellRenderer)) {
            this.column.customCellRenderer.forEach((renderer: any) => {
                this.componentReference.push(this.viewContainerRef.createComponent(renderer ?? DataGridDefaultCellRendererComponent));
            });

            this.componentReference.forEach((ref: any) => {
                ref.instance._column = this.column;
                ref.instance._data = this.data;
                ref.instance.onDataChange();
            });
        } else {
            this.componentReference = [
                this.viewContainerRef.createComponent(this.column.customCellRenderer ?? DataGridDefaultCellRendererComponent),
            ];

            this.componentReference[0].instance._column = this.column;
            this.componentReference[0].instance._data = this.data;
            this.componentReference[0].instance.onDataChange();
        }
    }

    public ngOnDestroy(): void {
        this.componentReference.forEach((ref: any) => ref.destroy());
    }
}
